// @flow

import React from 'react'
import Path from 'routes/path'

export type PropTypes = {
  room: {
    space: {
      username: string,
    },
    uid: string,
  },
  id: string,
  name: string,
  description: string,
  directReservationAccepted: boolean,
  todayOK: boolean,
  isLastMinuteDiscount: boolean,
  lastMinuteDiscountPercentage: boolean,
  hourlyPriceText: string,
  minRequiredHour: number,
  hourlyPriceUnitText: string,
  dailyPriceText: string,
  dailyPriceUnitText: string,
  optionCleaningPrice: number,
  optionCleaningPriceText: string,
  searchSessionId: string,
}

export default (props: PropTypes) => (
  <li className="space-plan__item">
    <h3 className="space-plan__title">{props.name}</h3>
    <ul className="space__reserveinfo space-plan__reserveinfo">
      {props.directReservationAccepted && (
        <li className="space__reserveinfo-now space__reserveinfo-item">
          <i className="fa fa-bolt fa-lg icon-direct mr5" />
          {i18n.t('page.room.directOK')}
          <span className="mod-evaluate__help">
            <i className="fa fa-question-circle mod-evaluate__question" />
            <span className="mod-tooltip mod-evaluate__help-tooltip">
              <span className="baloon baloon-top user-detail-baloon mod-tooltip__detail mod-evaluate__help-baloon">
                <span className="baloon-inner">
                  {i18n.t('page.room.captionDirectReservation')}
                </span>
              </span>
            </span>
          </span>
        </li>
      )}
      {props.todayOK && (
        <li className="space__reserveinfo-today space__reserveinfo-item">
          <i className="icon icon-spm-dash fa-lg icon-direct mr5" />
          {i18n.t('page.room.todayOK')}
        </li>
      )}
    </ul>
    <ul className="space-plan__info">
      {props.isLastMinuteDiscount && (
        <li className="space-plan__info-item space-plan__info-before">
          <i className="mr3 icon icon-spm-discount icon-discount" />
          <span>{i18n.t('page.room.lastMinuteDiscount.label1')}</span>
          {i18n.t('page.room.lastMinuteDiscount.label2')}
          <span>
            {i18n.t('page.room.lastMinuteDiscount.discount', {
              per: props.lastMinuteDiscountPercentage,
            })}
          </span>
        </li>
      )}
      {props.minRequiredHour && (
        <li className="space-plan__info-item space-plan__info-time">
          <i className="fa fa-clock-o icon-discount mr3" />
          {i18n.t('page.room.minimumPlanDetail', {
            hour: props.minRequiredHour,
          })}
        </li>
      )}
    </ul>
    {props.description && (
      <p className="space-plan__description">{props.description}</p>
    )}
    <div className="space-plan__price pc-hide__sm-show">
      <p>
        {props.hourlyPriceText && (
          <span>
            {i18n.t('page.room.priceRange', {
              min: props.hourlyPriceText,
              max: '',
              unit: props.hourlyPriceUnitText,
            })}
            <br />
          </span>
        )}
        {props.dailyPriceText && (
          <span>
            {i18n.t('page.room.priceRange', {
              min: props.dailyPriceText,
              max: '',
              unit: props.dailyPriceUnitText,
            })}
            <br />
          </span>
        )}
        {props.optionCleaningPrice > 0 && (
          <span>
            {i18n.t('page.room.managementFee', {
              price: props.optionCleaningPriceText,
            })}
          </span>
        )}
      </p>
    </div>
    <p className="space-plan__link">
      <a
        className="space-plan__link-button"
        href={Path.reservationRequest(
          props.room.space.username,
          props.room.uid,
          props.id,
          props.searchSessionId,
        )}
      >
        <i className="fa fa-angle-right mr3" />
        {i18n.t('page.room.reservePlan')}
      </a>
    </p>
  </li>
)



// WEBPACK FOOTER //
// ./src/components/molecules/room/PlanItem/index.jsx